/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const setBookingAttendanceInputSchema = z.object({
	attended: z.boolean(),
})

export type SetBookingAttendanceInputSchema = z.infer<typeof setBookingAttendanceInputSchema>
